// extracted by mini-css-extract-plugin
module.exports = {"card-footer":"CardFooter_card-footer__2CSml"};